module.exports = __webpack_public_path__ + "static/media/agreed.b34ba29c.svg";